// extracted by mini-css-extract-plugin
module.exports = {"LayoutHeader":"Layout_LayoutHeader__2_SQN","LayoutContent":"Layout_LayoutContent__1-FDC"};